<template>
  <v-row class="user-bio-panel">
    <!-- user profile -->
    <v-col cols="12">
      <v-card class="pt-10">
        <v-card-title class="justify-center flex-column">
          <v-avatar
            :color="data.image ? '' : 'primary'"
            :class="data.image ? '' : 'v-avatar-light-bg primary--text'"
            size="120"
            rounded
            class="mb-4"
          >
            <v-img
              v-if="data.thumbUrl"
              :src="data.thumbUrl"
            ></v-img>
            <span
              v-else
              class="font-weight-semibold text-5xl"
            >{{ avatarText(data.title) }}</span>
          </v-avatar>

          <span class="mb-2">{{ data.title | textEllipsis(90) }}</span>

          <v-chip
            label
            small
            color="primary"
            class="v-chip-light-bg text-sm font-weight-semibold primary--text text-capitalize"
          >
            {{ data.subtitle | textEllipsis(55) }}
          </v-chip>
        </v-card-title>

        <!-- <v-card-text class="d-flex justify-center flex-wrap mt-2 pe-sm-0">
          <div class="d-flex align-center me-8 mb-4">
            <v-avatar
              size="40"
              rounded
              color="primary"
              class="v-avatar-light-bg primary--text me-3"
            >
              <v-icon
                color="primary"
                size="22"
              >
                {{ icons.mdiCheck }}
              </v-icon>
            </v-avatar>

            <div>
              <h3 class="text-xl font-weight-medium mb-n1">
                {{ kFormatter(data.taskDone) }}
              </h3>
              <span>Task Done</span>
            </div>
          </div>

          <div class="d-flex align-center mb-4 me-4">
            <v-avatar
              size="40"
              rounded
              color="primary"
              class="v-avatar-light-bg primary--text me-3"
            >
              <v-icon
                color="primary"
                size="22"
              >
                {{ icons.mdiBriefcaseVariantOutline }}
              </v-icon>
            </v-avatar>

            <div>
              <h3 class="text-xl font-weight-medium mb-n1">
                {{ kFormatter(data.projectDone) }}
              </h3>
              <span>Project Done</span>
            </div>
          </div>
        </v-card-text> -->

        <v-card-actions
          v-if="$can('update', 'Event')"
          class="justify-center"
        >
          <v-btn
            color="primary"
            :to="{ name: 'event-edit', params: { id: data.id } }"
          >
            {{ t('Edit') }}
          </v-btn>
        </v-card-actions>
      </v-card>

      <!-- edit profile dialog data -->
      <!-- <event-bio-edit
        v-if="$can('update', 'Event')"
        :data="data"
        :handle-submit="handleUpdate"
        :is-bio-dialog-open.sync="isBioDialogOpen"
      ></event-bio-edit> -->
    </v-col>
  </v-row>
</template>

<script>
import { mdiCheck, mdiBriefcaseVariantOutline, mdiCheckboxBlankCircle } from '@mdi/js'
import { avatarText, kFormatter } from '@core/utils/filter'
import { useUtils } from '@core/libs/i18n'
import useEventsList from '../../event-list/useEventsList'

// import EventBioEdit from './EventBioEdit.vue'

export default {
  components: {
    // EventBioEdit,
  },
  props: {
    data: {
      type: Object,
      required: true,
    },
    handleUpdate: {
      type: Function,
      required: true,
    },
  },
  setup() {
    const { t } = useUtils()
    const { resolveUserStatusVariant, resolveUserRoleVariant } = useEventsList()

    // const isBioDialogOpen = ref(false)

    // ui
    const resolveCurrentPlanValue = plan => {
      if (plan === 'basic') return '0'
      if (plan === 'standard') return '99'
      if (plan === 'enterprise') return '499'
      if (plan === 'company') return '999'

      return '0'
    }

    return {
      resolveUserStatusVariant,
      resolveUserRoleVariant,
      avatarText,
      kFormatter,
      resolveCurrentPlanValue,

      // isBioDialogOpen,
      icons: {
        mdiCheck,
        mdiBriefcaseVariantOutline,
        mdiCheckboxBlankCircle,
      },

      t,
    }
  },
}
</script>
